export default __webpack_public_path__ + "static/media/gallery_00.e8ba393d.jpg";